<soh-simple-list [items]="items"
  [className]="className"
  [title]="'CUSTOMER_DETAILS.TITLE' | translate"></soh-simple-list>